import React, { memo, useContext, useEffect, useRef, useState } from 'react';
import { SUBSCRIBE_RETRY_TIME } from '../../../../constant';
import { AVContext } from '../../../../context';
import EVENTS from '../../../../events';
const TokboxRemoteVideo = ({ videoStream, initialAudioVolume, subscribeToVideo, }) => {
    const { av } = useContext(AVContext);
    const [retryCount, setRetryCount] = useState(0);
    const subscriberRef = useRef();
    const ref = useRef(null);
    const retryTimerRef = useRef();
    const unmountedRef = useRef(false);
    useEffect(() => {
        const appendVideoElement = (videoElement) => {
            videoElement.style.width = '100%';
            videoElement.setAttribute('disablePictureInPicture', 'true');
            videoElement.setAttribute('playsInline', 'true');
            ref.current?.append(videoElement);
        };
        const subscribe = async () => {
            try {
                subscriberRef.current = await av.subscribe(videoStream, initialAudioVolume ?? 100);
                const videoElement = subscriberRef.current?.videoElement();
                if (videoElement) {
                    appendVideoElement(videoElement);
                }
                else if (subscriberRef.current) {
                    subscriberRef.current.on('videoElementCreated', event => {
                        av.logger(EVENTS.AV_DEBUG_MEDIA_ELEMENT_CREATED, {
                            is_local: false,
                        });
                        appendVideoElement(event.element);
                    });
                }
            }
            catch (error) {
                if (!unmountedRef.current) {
                    retryTimerRef.current = window.setTimeout(() => {
                        setRetryCount(retryCount + 1);
                    }, SUBSCRIBE_RETRY_TIME);
                }
            }
        };
        subscribe();
    }, [av, videoStream, initialAudioVolume, retryCount]);
    useEffect(() => {
        if (subscriberRef.current && subscribeToVideo !== undefined) {
            subscriberRef.current.subscribeToVideo(subscribeToVideo);
        }
    }, [subscribeToVideo]);
    useEffect(() => {
        return () => {
            if (subscriberRef.current) {
                av.unsubscribe(subscriberRef.current);
            }
        };
    }, [av]);
    useEffect(() => {
        return () => {
            if (retryTimerRef.current) {
                clearTimeout(retryTimerRef.current);
                retryTimerRef.current = undefined;
            }
            unmountedRef.current = true;
        };
    }, []);
    return React.createElement("div", { ref: ref });
};
export default memo(TokboxRemoteVideo);
//# sourceMappingURL=tokboxRemoteVideo.js.map